import { useSuspenseQuery } from '@apollo/client';
import { useMemo } from 'react';

import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import { ModulesContextType } from '../../contexts/modules-context/modules-context';
import { EntityPageModulesDocument } from '../../graphql/queries/entity-page-modules-query.gql-types';

type Responses =
  | { error: true; data: undefined }
  | { error: false; data: ModulesContextType };

export const useEntityPageModules = (): Responses => {
  const { pageContext } = usePageContext();

  const { data, error } = useSuspenseQuery(EntityPageModulesDocument, {
    variables: {
      id: pageContext.pageSlug,
    },
  });

  return useMemo((): Responses => {
    const entityPage = data.entityPageEX;

    if (error || entityPage?.__typename !== 'EntityPage') {
      return { error: true, data: undefined };
    }

    const modulesCollection = entityPage.modules?.collection ?? [];

    const pageModules = modulesCollection
      .filter(
        (module) =>
          module?.__typename === 'EntityPageGenericModule' ||
          module?.__typename === 'EntityPageAboutUsModule'
      )
      .filter((module) => module.type !== 'header' && module.type !== 'kununu'); //TODO remove kununu when backend is cleaned up

    const pageModulesByType = pageModules
      .map((module) => module?.type)
      .filter((type) => type !== undefined && type !== 'kununu'); //TODO remove kununu when backend is cleaned up

    if (pageModulesByType.length === 0) {
      return { error: true, data: undefined };
    }

    const hasNewsModule = !!pageModules?.find(
      (pageModule) => pageModule?.type === 'news'
    );

    const headerModule = pageContext.headerModule;
    const headerModuleCompanyIndustry =
      headerModule?.content?.__typename === 'EntityPageCompanyHeaderContent'
        ? headerModule?.content.company?.industry
        : undefined;

    return {
      error: false,
      data: {
        industryId: headerModuleCompanyIndustry?.id,
        hasNewsModule: hasNewsModule,
        pageModulesByType: pageModulesByType,
        headerModule: headerModule,
        pageModules: pageModules,
      },
    };
  }, [data, error, pageContext]);
};
